module.exports = __webpack_public_path__ + "static/media/logo_color.8f2c5b94.png";